import { Action } from '../../shared/xs/actions';
import { ImprovementModel } from '../models/improvement.model';

export class GetLatestImprovementAction implements Action {
  static readonly type = '[Improvements] get latest';
}

export type GetLatestImprovementResponse = ImprovementModel;
